$(function() {
	
    $('#collection-description').readmore({
		collapsedHeight: 42
	});

	//search box
	$(".search-header button[type='submit']").click(function( event ) {
		var box = $(this).siblings("input")
		if ($.trim(box.val()).length === 0){
			box.focus();
			event.preventDefault();
		}
	})
	$(".search-bar-open").click(function() {
		$("#search-bar").addClass("active");
		$("#search-bar input[type='search']").focus();
	})
	$(".search-bar-close").click(function( event ) {
		$("#search-bar").removeClass("active");
	})
	$("div.search-wrapper").click(function( event ) {
		event.stopPropagation();
	})
	
	//hide the memu items that contains "All"
	function hideItemsStartsWithAll() {
		var txt = $(this).text();
			if (txt.toLowerCase().startsWith("all")){
		  	$(this).parent().addClass("hidden");
		}
	}
	$(".submenu a").each( hideItemsStartsWithAll );
	
	
	$(".promo-countdown").each(function(index, element ) {
		countdown(element);
	})
	
	//size guide 
	$('input[name="sg_unit"]').change(function(){
      	var selected_unit=$('input[name="sg_unit"]:checked').val();
        sg_toggle_unit(selected_unit);
    });   
	$('input.sg_country').change(function(){
		var selected_countries=[];
		$('input.sg_country:checked').each(function(i){
			selected_countries[i] = $(this).val();
		});
		if(selected_countries.length==0){
			$(this).prop("checked", true);
			selected_countries[0] = $(this).val();
		}else{
			sg_toggle_country(selected_countries);
		}
    });   
	sg_resetSizeGuide();
  
    $(".accordion h4").click(function(){
      $(this).toggleClass("collapsed");
    });
});

function sg_toggle_unit(unit){
	if(unit== "inches"){
		$('.size-guide.cm').addClass("hidden");
		$('.size-guide.inch').removeClass("hidden");
		$.cookie("sg_unit", unit, {expires:365, path:'/'});
	}else if (unit == "cm"){
		$('.size-guide.inch').addClass("hidden");
		$('.size-guide.cm').removeClass("hidden");
		$.cookie("sg_unit", unit, {expires:365, path:'/'});
	}else{
		console.log("Size Guide - unknown unit: "+unit);
	}
}

function sg_toggle_country(countries){
	$(".size-guide .country").hide();
	for(var i=0; i<countries.length; i++){
		$(".size-guide .country." + countries[i]).show();
	}
	$.cookie("sg_country", countries, {expires:365, path:'/'});
}

function sg_resetSizeGuide(){
	//get unit from cookie and show the table with the correct unit
	var unit=$.cookie("sg_unit");
	if(!unit){
		unit="inches";
	};
	sg_toggle_unit(unit);
	$('input[name="sg_unit"][value='+unit+']').prop("checked", true);
	
	//get countries from cookie and show the columns with the correct country
	var cookie_country=$.cookie("sg_country");
	//if cookie is not set
	if(cookie_country){
		cookie_country=cookie_country.split(',');
	}else{
		cookie_country = [];
	}
	var country=[];
	$('input.sg_country').each(function(i){
		country[i] = $(this).val();
		 $(this).prop("checked", false);
	});
	//remove invalid countries
	cookie_country = cookie_country.filter(function(n) {
		return country.indexOf(n) !== -1;
	});
	if(cookie_country.length==0 ){
		cookie_country = sg_default_countries();
	}
	for(var i=0; i<cookie_country.length; i++){
		$('input.sg_country[value='+cookie_country[i]+']').prop("checked", true);
	}
	sg_toggle_country(cookie_country);
}

function sg_default_countries(){
	var all_countries=[];
	$('input.sg_country').each(function(i){
		all_countries[i] = $(this).val();
	});
	if($('.sg_wrapper').width()<500 && all_countries.length>0){
		return [all_countries[0]];
	}else{
		return all_countries;
	}
}

function countdown(element){
	
	var date = $(element).data("date"),
		time = $(element).data("time"),
		eventTime = moment.tz(date + " " + time, 'DD-MM-YYYY HH:mm', "Europe/London");
	if (eventTime.isValid()) {
        var diffTime = eventTime.unix() - moment().unix(),
        duration = moment.duration(diffTime * 1000, 'milliseconds'),
        interval = 1000;
		

		//Update the count down every 1 second
		var x = setInterval(function() {
            duration = moment.duration(duration.asMilliseconds() - interval, 'milliseconds');
            var d = Math.floor(duration.asDays()),
                h = duration.hours(),
                m = duration.minutes(),
                s = duration.seconds();
			
            m = $.trim(m).length === 1 ? '0' + m : m;
            s = $.trim(s).length === 1 ? '0' + s : s;
			
			var cd = "";
			if(d > 0 ){
				cd = "<span>" + d + "</span>d <span>" + h + "</span>h <span>" + m + "</span>m";
			}else {
				if(h > 0){
					cd = "<span>" + h + "</span>h <span>" + m + "</span>m <span>" + s + "</span>s ";
				} else{
					cd = "<span>" + m + "</span>m <span>" + s + "</span>s ";
				}
			}
			
			// Output the result
			element.innerHTML = "Ends in " + cd;
			
			// If the count down is over, write some text 
			if (duration <= 0) {
				clearInterval(x);
				element.innerHTML = "EXPIRED";
			}
		}, interval);
	}else{
		console.log("Countdown Error: Invalid date.");
	}
}